<template>
  <main class="page-operative page-operative-dashboard">
    <div class="container-fluid">
      <div class="d-flex align-items-start justify-content-between flex-wrap flex-md-nowrap mb-5">
        <PageTitle class="mb-2 mb-md-0">Dashboard</PageTitle>

        <div v-if="!isLoadingData && !errorLoadingData" class="actions d-flex">
          <FormInputSelectWidget :required="false" :options="yearOptions" v-model="year" @input="selectYear" hideLabel class="mr-4" />
          <button v-if="userIsAdmin || userIsContextCompanyOwner || userIsContextCompanyConsultant" class="btn btn-outline-primary" @click="openWidgetConfigDrawer">
            Configura Dashboard
          </button>
        </div>
      </div>

      <LoadingDataLoader v-if="isLoadingData" />
      <ErrorOnLoadingDataFeedback v-else-if="errorLoadingData" />
      <div v-else-if="widgets" class="row report-texts-size">
        <!-- Turnover Trend -->
        <div v-if="widgets['andamento-fatturato']" class="col-md-6 col-xl-4 mb-4">
          <DashboardWidgetTurnoverTrend :values="widgets['andamento-fatturato']" />
        </div>

        <!-- Cash Flow Widget -->
        <div v-if="widgets['cashflow-annuale']" class="col-md-6 col-xl-4 mb-4">
          <DashboardWidgetCashFlow :values="widgets['cashflow-annuale']" />
        </div>

        <div v-if="widgets['conto-economico-annuale']" class="col-md-6 col-xl-4 mb-4">
          <DashboardWidgetContoEconomico :values="widgets['conto-economico-annuale']" />
        </div>

        <div v-if="widgets['stato-patrimoniale-annuale']" class="col-md-6 col-xl-4 mb-4">
          <DashboardWidgetStatoPatrimoniale :values="widgets['stato-patrimoniale-annuale']" />
        </div>

        <!-- KPI Widget -->
        <div v-if="widgets['kpi']" class="col-md-6 col-xl-4 mb-4">
          <DashboardWidgetKpi :kpi="widgets['kpi']" />
        </div>

        <!-- ROI Widget GAUGE -->
        <div v-if="widgets['roi']" class="col-md-6 col-xl-4 mb-4">
          <DashboardWidgetROI :min="widgets['roi'].min" :max="widgets['roi'].max" :value="widgets['roi'].value" />
        </div>

        <!-- ROE Widget GAUGE -->
        <div v-if="widgets['roe']" class="col-md-6 col-xl-4 mb-4">
          <DashboardWidgetROE :min="widgets['roe'].min" :max="widgets['roe'].max" :value="widgets['roe'].value" />
        </div>

        <!-- ROS Widget GAUGE -->
        <div v-if="widgets['ros']" class="col-md-6 col-xl-4 mb-4">
          <DashboardWidgetROS :min="widgets['ros'].min" :max="widgets['ros'].max" :value="widgets['ros'].value" />
        </div>

        <!-- Indice di indipendenza da terzi Widget GAUGE -->
        <div v-if="widgets['indice-indipendenza-terzi']" class="col-md-6 col-xl-4 mb-4">
          <DashboardWidgetIndiceIndipendenzaTerzi :min="widgets['indice-indipendenza-terzi'].min" :max="widgets['indice-indipendenza-terzi'].max" :value="widgets['indice-indipendenza-terzi'].value" />
        </div>

        <!-- Turnover Attività GAUGE -->
        <div v-if="widgets['turnover-attivita']" class="col-md-6 col-xl-4 mb-4">
          <DashboardWidgetTurnoverAttivita :min="widgets['turnover-attivita'].min" :max="widgets['turnover-attivita'].max" :value="widgets['turnover-attivita'].value" />
        </div>

        <!-- Zed Score GAUGE -->
        <div v-if="widgets['zed-score']" class="col-md-6 col-xl-4 mb-4">
          <DashboardWidgetZedScore :min="widgets['zed-score'].min" :max="widgets['zed-score'].max" :value="widgets['zed-score'].value" />
        </div>

        <div v-if="widgets['conto-economico']" class="col-md-6 col-xl-4 mb-4">
          <DashboardWidgetContoEconomicoSankey :values="widgets['conto-economico']" />
        </div>

        <!-- Redditività STACK LINE -->
        <div v-if="widgets['analisi-redditivita']" class="col-md-6 col-xl-4 mb-4">
          <DashboardWidgetRedditivita :values="widgets['analisi-redditivita']" />
        </div>

        <div v-if="widgets['analisi-reddituale-previsionale']" class="col-md-6 col-xl-4 mb-4">
          <DashboardWidgetAnalisiRedditualePrevisionale :values="widgets['analisi-reddituale-previsionale']" />
        </div>

        <!-- Cash Flow SMOOTH LINE -->
        <div v-if="widgets['cash-flow-line']" class="col-md-6 col-xl-4 mb-4">
          <DashboardWidgetCashFlowLine :values="widgets['cash-flow-line']" />
        </div>

        <!-- Cassa e Disavanzo SMOOTH LINE -->
        <div v-if="widgets['cassa-disavanzo']" class="col-md-6 col-xl-4 mb-4">
          <DashboardWidgetCassaDisavanzo :values="widgets['cassa-disavanzo']" />
        </div>

        <!-- Andamento delle vendite BAR STACK -->
        <div v-if="widgets['andamento-vendite']" class="col-md-6 col-xl-4 mb-4">
          <DashboardWidgetAndamentoVendite :values="widgets['andamento-vendite']" />
        </div>

        <div v-if="widgets['valutazione-azienda']" class="col-md-6 col-xl-4 mb-4">
          <DashboardWidgetCompanyJudgement :values="widgets['valutazione-azienda']" />
        </div>

        <div v-if="widgets['fabbisogno-finanziamento']" class="col-md-6 col-xl-4 mb-4">
          <DashboardWidgetFabbisognoFinanziario :values="widgets['fabbisogno-finanziamento']" />
        </div>

        <div v-if="widgets['analisi-reddituale-consuntiva']" class="col-md-6 col-xl-4 mb-4">
          <DashboardWidgetAnalisiRedditualeConsuntiva :values="widgets['analisi-reddituale-consuntiva']" />
        </div>

        <div v-if="widgets['analisi-indicatori']" class="col-md-6 col-xl-4 mb-4">
          <DashboardWidgetAnalisiIndicatori :values="widgets['analisi-indicatori']" />
        </div>
      </div>
    </div>
    <DashboardConfigSideDrawer v-if="!isLoadingData && !errorLoadingData && showDrawer" @close="showDrawer = false" @reload="closeDrawerAndReload" :showDrawer="showDrawer" :company="company" />
  </main>
</template>

<script>

import operativePageMixin from '@/mixins/operativePage';
import loadingDataMixin from '@/mixins/loadingData';

export default {
  mixins: [operativePageMixin, loadingDataMixin],
  components: {
    PageTitle: () => import('../../../components/Layout/LayoutOperative/PageTitle'),
    ErrorOnLoadingDataFeedback: () => import('../../../components/Operative/ErrorOnLoadingDataFeedback'),
    LoadingDataLoader: () => import('../../../components/Operative/LoadingDataLoader'),

    DashboardWidgetTurnoverTrend: () => import('../../../components/Dashboard/Widgets/DashboardWidgetTurnoverTrend'),
    DashboardWidgetAnalisiIndicatori: () => import('../../../components/Dashboard/Widgets/DashboardWidgetAnalisiIndicatori'),
    DashboardWidgetContoEconomico: () => import('../../../components/Dashboard/Widgets/DashboardWidgetContoEconomico'),
    DashboardWidgetStatoPatrimoniale: () => import('../../../components/Dashboard/Widgets/DashboardWidgetStatoPatrimoniale'),
    DashboardWidgetFabbisognoFinanziario: () => import('../../../components/Dashboard/Widgets/DashboardWidgetFabbisognoFinanziario'),
    DashboardWidgetAnalisiRedditualePrevisionale: () => import('../../../components/Dashboard/Widgets/AnalisiReddituale/DashboardWidgetAnalisiRedditualePrevisionale'),
    DashboardWidgetAnalisiRedditualeConsuntiva: () => import('../../../components/Dashboard/Widgets/AnalisiReddituale/DashboardWidgetAnalisiRedditualeConsuntiva'),
    DashboardWidgetRedditivita: () => import('../../../components/Dashboard/Widgets/LineStack/DashboardWidgetRedditivita'),
    DashboardWidgetCashFlow: () => import('../../../components/Dashboard/Widgets/DashboardWidgetCashFlow'),
    DashboardWidgetCashFlowLine: () => import('../../../components/Dashboard/Widgets/LineSmooth/DashboardWidgetCashFlowLine'),
    DashboardWidgetAndamentoVendite: () => import('../../../components/Dashboard/Widgets/BarStack/DashboardWidgetAndamentoVendite'),
    DashboardWidgetCassaDisavanzo: () => import('../../../components/Dashboard/Widgets/LineSmooth/DashboardWidgetCassaDisavanzo'),
    DashboardWidgetKpi: () => import('../../../components/Dashboard/Widgets/DashboardWidgetKpi'),
    DashboardWidgetROI: () => import('../../../components/Dashboard/Widgets/Gauges/DashboardWidgetROI'),
    DashboardWidgetIndiceIndipendenzaTerzi: () => import('../../../components/Dashboard/Widgets/Gauges/DashboardWidgetIndiceIndipendenzaTerzi'),
    DashboardWidgetTurnoverAttivita: () => import('../../../components/Dashboard/Widgets/Gauges/DashboardWidgetTurnoverAttivita'),
    DashboardWidgetZedScore: () => import('../../../components/Dashboard/Widgets/Gauges/DashboardWidgetZedScore'),
    DashboardWidgetROS: () => import('../../../components/Dashboard/Widgets/Gauges/DashboardWidgetROS'),
    DashboardWidgetROE: () => import('../../../components/Dashboard/Widgets/Gauges/DashboardWidgetROE'),
    DashboardWidgetContoEconomicoSankey: () => import('../../../components/Dashboard/Widgets/DashboardWidgetContoEconomicoSankey'),
    DashboardWidgetCompanyJudgement: () => import('../../../components/Dashboard/Widgets/DashboardWidgetCompanyJudgement'),
    DashboardConfigSideDrawer: () => import('../../../components/Dashboard/DashboardConfigSideDrawer'),
    FormInputSelectWidget: () => import('../../../../libs/Form/components/Inputs/Widgets/FormInputSelectWidget'),
  },
  data () {
    return {
      widgets: null,
      years: null,
      year: null,
      showDrawer: false,
    };
  },
  computed: {
    yearOptions () {
      if (!this.years) {
        return [];
      }

      return this.years.map(y => {
        return {
          value: y,
          label: y,
        };
      });
    },
  },
  methods: {
    retrieveData () {
      if (!this.company) {
        return;
      }

      this.resetErrorOnLoadingData();
      this.setDataLoading();

      this.$api.getForecastDashboard(this.company?.id, this.year)
        .then(res => {
          this.years = res?.data?.years || [];
          this.year = res?.data?.year || new Date().getFullYear();
          this.widgets = res?.data?.widgets || {};
        })
        .catch(this.setErrorOnLoadingData)
        .finally(this.setDataLoaded)
      ;
    },
    selectYear () {
      this.retrieveData();
    },
    openWidgetConfigDrawer () {
      this.showDrawer = true;
    },
    closeDrawerAndReload () {
      this.showDrawer = false;
      this.retrieveData();
    },
  },
  watch: {
    company () {
      this.retrieveData();
    },
  },
};

</script>

<style lang="scss">

.page-operative-dashboard {
  .operative-table {
    .operative-table-header-column {
      min-width: 0;
    }

    .operative-table-value-column {
    }
  }

  .operative-table-body-row.only-semaphore .operative-table-kpi-value-column.operative-table-value-column {
    min-width: 0;
  }
}

</style>
